import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import imgCreateCharacter from "../../../assets/images/home/page4.webp";
import imgCreateCharacterZh from "../../../assets/images/home/page4_zh.webp";
import AvatarSlider from "../../../Components/AvatarSlider/index";
import Button from "../../../Components/Button/Button";
import "./CreateCharacter.css";

const CreateCharacter = () => {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language?.startsWith("zh");
  const points = t("home.create_character.points", { returnObjects: true });

  const history = useHistory();

  const handleCreateClick = () => {
    history.push("/download");
    window.scrollTo(0, 0);
  };

  return (
    <section className="create-character-wrapper">
      <div className="section-divider-top">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" preserveAspectRatio="none">
          <path d="M1440,120C1440,120,1161.5,10,725.694,10C272.5,10,0,116.95,0,116.95V120H1440Z" fill="#F0EFF7"></path>
        </svg>
      </div>
      <div className="create-character-container">
        {/* Left Side: Image */}
        <div className="create-character-visual">
          <img src={isZh ? imgCreateCharacterZh : imgCreateCharacter} alt="Create AI Character" className="create-main-img" />
        </div>

        {/* Right Side: Content */}
        <div className="create-character-content">
          <h2 className="create-title global-title">{t("home.create_character.title")}</h2>
          <p className="create-subtitle global-text">{t("home.create_character.subtitle")}</p>

          <div className="create-label-text global-subtitle">{t("home.create_character.label")}</div>
          <div className="create-points-grid">
            {Array.isArray(points) && points.map((point, index) => (
              <div key={index} className="create-point-item global-text">
                <div className="point-bullet global-diamond-icon"></div>
                {point}
              </div>
            ))}
          </div>

          <Button
            title={t("home.create_character.btn")}
            onClick={handleCreateClick}
            className="create-cta-btn"
          />
        </div>
      </div>

      {/* Community Section footer */}
      <div className="community-showcase">
        <AvatarSlider />
        <p className="community-explore-text global-text">{t("home.create_character.explore")}</p>
      </div>
      <div className="create-character-divider-bottom">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" preserveAspectRatio="none">
          <path d="M0,0C0,0,436.847,85.5,720,85.5C1003.15,85.5,1440,0,1440,0V120H0V0Z" fill="#ffffff"></path>
        </svg>
      </div>
    </section>
  );
};

export default CreateCharacter;
